import script from "./card-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./card-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./card-setting-ly.vue?vue&type=style&index=0&id=4f64835d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f64835d"]])

export default __exports__